module.exports = __webpack_public_path__ + "img/tablebg.1e121bc4.png";